<script>
    import R, {LOADER} from "../lib/requests";
    import {HOTEL_TYPE} from "../lib/constants.js";
    import AppIcon from "../components/icons/AppIcon.svelte";

    let hotels = null;
    let villas = null;

    const load = () => {
        const onSuccess = result => {
            result.map(item => {
                if (item.type == HOTEL_TYPE.HOTEL) {
                    if (!hotels) hotels = [];
                    hotels.push(item);
                } else {
                    if (!villas) villas = [];
                    villas.push(item);
                }
            })
        }

        const onFailure = err => {
        };

        R.handle(R.hotel.index, [], onSuccess, onFailure, LOADER.PAGE);
    }

    load();
</script>

<div class="page-header solid">
    <h1>Hotels</h1>
</div>

{#if hotels || villas}
    {#if hotels}
        <h3 class="mb-4">Enorme Hotels</h3>
        {#each hotels as item}
            <div>
                {#if item.url}
                    <a href="{ item.url }" target="_blank">{ item.name }</a>
                {:else}
                    { item.name }
                {/if}
            </div>
        {/each}
    {/if}
    {#if villas}
        <h3 class="mb-4">Enorme Villas</h3>
        {#each villas as item}
            <div>
                {#if item.url}
                    <a href="{ item.url }" target="_blank">{ item.name }</a>
                {:else}
                    { item.name }
                {/if}
            </div>
        {/each}
    {/if}
{/if}
